import React from 'react';
import IconRestartStyled from './IconRestart.styled';

const IconRestart = styleProps => (
  <IconRestartStyled
    className="selectIcon"
    viewBox="0 0 100 125"
    {...styleProps}
  >
    <title>Restart</title>
    <path d="M90.9 44.7c-3.7 0-6.6 3-6.6 6.6 0 8.7-7.1 15.9-15.9 15.9H36.7l3.1-3.1c2.6-2.6 2.6-6.8 0-9.4a6.64 6.64 0 0 0-9.4 0L16 69.1a6.64 6.64 0 0 0 0 9.4l14.4 14.4c1.3 1.3 3 1.9 4.7 1.9 1.7 0 3.4-.6 4.7-1.9 2.6-2.6 2.6-6.8 0-9.4l-3.1-3.1h31.7c16.1 0 29.1-13.1 29.1-29.1 0-3.6-3-6.6-6.6-6.6zM31.6 32.8h31.7l-3.1 3.1a6.64 6.64 0 0 0 0 9.4c1.3 1.3 3 1.9 4.7 1.9s3.4-.6 4.7-1.9L84 30.9c2.6-2.6 2.6-6.8 0-9.4L69.6 7.1a6.64 6.64 0 0 0-9.4 0 6.64 6.64 0 0 0 0 9.4l3.1 3.1H31.6c-16.1 0-29.1 13.1-29.1 29.1 0 3.7 3 6.6 6.6 6.6s6.6-3 6.6-6.6c.1-8.8 7.2-15.9 15.9-15.9z" />
  </IconRestartStyled>
);

export default IconRestart;



// WEBPACK FOOTER //
// ./src/components/atoms/IconRestart/IconRestart.js